<app-side-bar></app-side-bar>

<p style="padding-left: 50px;">Login Success, Redirecting back to previous page...</p>